<div class="flex w-full flex-col" *cftI18n="let t">
  <!--  recommended by mobi -->
  @if (showRecommendedBy) {
    <div class="hidden justify-end pr-lg pb-md lg:inline-flex">
      <ng-content select="cft-recommended-by"></ng-content>
    </div>
  }
  <div
    class="isolate flex w-full flex-col gap-x-md rounded-lg bg-white pt-md pr-xl pb-xl pl-xl shadow-5 lg:flex-row lg:pb-lg"
  >
    <!--  Logo -->
    <div
      class="relative z-10 -mt-[46px] mb-xl h-[150px] w-[150px] shrink-0 rounded-lg border-[5px] border-grey-50 bg-white p-md"
    >
      @if (pro.profile.logoImage?.url; as logoUrl) {
        <img
          [ngSrc]="logoUrl"
          width="140"
          height="140"
          class="z-50 h-full w-full bg-white object-contain"
          [alt]="pro | cftProProfileLogoAltText"
          data-testid="company logo"
        />
      } @else {
        <div class="flex h-full w-full items-center justify-center bg-petrol-300 text-2xl font-bold">
          {{ pro.companyName | bgoCompanyInitials }}
        </div>
      }
      @if (pro.profile.yearsAsTopPartner?.length && pro.profile.yearsAsTopPartner; as years) {
        <bgo-top-partner-banner
          [bannerText]="t('proProfile.intro.topPartner', {year: years | bgoMax})"
          class="absolute top-0 left-[-13.5px] z-10 scale-[115%]"
        />
      }
    </div>
    <!-- main content-->
    <div class="flex flex-col">
      <div class="flex flex-row items-center pb-sm">
        <div class="flex w-full items-center">
          <span class="flex items-center justify-center rounded-1 bg-grey-50 px-[9.75px] py-[5px]">
            <fa-icon [icon]="faLocation" class="text-sm"></fa-icon>
          </span>
          @if (pro.assignmentRegions.length) {
            <cft-chip class="ml-sm" [colour]="'grey-lighter'">{{
              firstAssigmentRegion(pro.assignmentRegions)
            }}</cft-chip>
          } @else {
            <div class="pr-xs pl-xs text-base">{{ mainPostalCodeAndLocality }}</div>
          }
          @if ((hasMultipleLocations && !pro.assignmentRegions.length) || hasMultipleAssigmentRegions) {
            <div class="pr-xs pl-xs">
              <span class="cursor-pointer" [cftDropdown]="locationsDropdown" (click)="$event.stopPropagation()">
                <span>+{{ pro.locations.length - 1 }}</span>
                <fa-icon [icon]="faCarretDown" class="pl-2xs"></fa-icon>
              </span>
            </div>
          }
          <cft-dropdown #locationsDropdown="cftDropdown">
            <ng-template cftDropdownContent>
              <div class="divide-y focus:outline-none">
                @if (hasMultipleAssigmentRegions) {
                  @for (region of pro.assignmentRegions; track region; let i = $index) {
                    @if (i > 0) {
                      <a class="group flex items-center px-sm py-xs text-sm"> {{ region.label }} </a>
                    }
                  }
                } @else if (!pro.assignmentRegions.length) {
                  @for (location of pro.locations; track location; let i = $index) {
                    @if (i > 0) {
                      <a class="group flex items-center px-sm py-xs text-sm">
                        {{ location.place.postalCode }} {{ location.place.locality }}
                      </a>
                    }
                  }
                }
              </div>
            </ng-template>
          </cft-dropdown>
        </div>
      </div>
      <div class="items-center justify-center pb-sm text-lg font-extrabold">{{ pro.companyName }}</div>

      <!--   Rating and industries -->
      <div class="flex flex-col lg:flex-row lg:pb-md">
        <div class="flex flex-row flex-wrap items-center">
          @for (ind of previewIndustries; track ind; let i = $index; let last = $last) {
            <div class="text-base font-medium text-grey-700">{{ ind }}</div>
            @if (!last && previewIndustries.length > 1) {
              <div class="pr-2xs pl-2xs text-sm font-medium text-grey-700">•</div>
            }
          }
          @if (pro.industries.length > industryPreviewLength) {
            <span class="cursor-pointer pl-xs" [cftDropdown]="industriesDropdown" (click)="$event.stopPropagation()">
              <span>+{{ pro.industries.length - industryPreviewLength }}</span>
              <fa-icon [icon]="faCarretDown" class="pl-2xs"></fa-icon>
            </span>
          }
          <cft-dropdown #industriesDropdown="cftDropdown">
            <ng-template cftDropdownContent>
              <div class="divide-y focus:outline-hidden">
                @for (ind of pro.industries; track ind; let i = $index) {
                  @if (i + 1 > industryPreviewLength) {
                    <a class="group flex items-center px-sm py-xs text-sm">
                      {{ ind }}
                    </a>
                  }
                }
              </div>
            </ng-template>
          </cft-dropdown>

          <div class="h-fit w-full pt-sm lg:inline-flex lg:w-fit lg:pt-0 lg:pl-md">
            <ng-content select="cft-google-rating"></ng-content>
          </div>
        </div>
      </div>

      <!--CTAs-->
      <div class="hidden items-center gap-x-sm lg:flex lg:flex-row">
        <ng-content select="[content=requestButton]"></ng-content>
        <ng-content select="[content=messageButton]"></ng-content>
        <div class="text-xs text-grey-700 lg:flex lg:flex-col">
          <ng-content select="[content=guaranteeText1]"></ng-content>
          <ng-content select="[content=guaranteeText2]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
